<template>
  <div>
    <div class="block">
      <div class="block-title">代理结佣管理</div>
      <el-form :model="searchForm" class="search-form">
        <el-form-item label="数据日期">
          <el-date-picker v-model="searchForm.time" type="daterange" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item label="达人昵称/用户id" prop="fidOrName">
          <el-input v-model="searchForm.fidOrName" :max-length="200" placeholder="达人昵称/用户id" />
        </el-form-item>
        <el-form-item label="代理/ID" prop="agent">
          <el-input v-model="searchForm.agent" :max-length="200" placeholder="代理/ID" />
        </el-form-item>
        <el-form-item label="结佣状态" prop="payStatus">
          <el-select v-model="searchForm.payStatus" placeholder="结佣状态">
            <el-option v-for="item in payStatusList" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="结佣日期">
          <el-date-picker v-model="searchForm.payTime" type="date" range-separator="-" placeholder="选择结佣日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="pickerOptions" />
        </el-form-item>
        <el-form-item>
          <!-- 操作按钮 -->
          <el-button type="warning" @click="onFormSearch">查询</el-button>
          <el-button type="warning" plain @click="onFormReset">重置</el-button>
          <el-button :loading="exportLoading" @click="onFormExport">导出数据</el-button>

        </el-form-item>
      </el-form>

    </div>
    <div class="block block-top">
      <div class="toolbar">
        <!-- 发起结佣 -->
        <set-settlement :is-show-settlement="searchForm.appKey &&
          defaultAppKey &&
          searchForm.appKey === defaultAppKey
          " @refresh="onFormReset" />

      </div>
      <!-- 表格-->
      <el-table ref="table" header-row-class-name="header" border highlight-current-row :data="table.dataSource"
        v-loading="table.loading">
        <el-table-column prop="dataDateStr" label="数据日期" />
        <el-table-column prop="userName" label="达人">
          <template #default="{ row }">
            <div class="table-user">
              <img :src="row.headImg" />
              <div class="table-user__right">
                <div>{{ row.fansName }}</div>
                <div>用户ID：{{ row.reference }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="appName" label="关联小程序" />
        <el-table-column prop="userName" label="代理" />
        <el-table-column prop="videoPayCount">
          <template #header>
            <div>
              待结佣订单
              <el-tooltip class="item" effect="dark" placement="top">
                <div slot="content">订单变为已结算状态后，进入待结佣</div>
                <el-icon class="el-icon-question" />
              </el-tooltip>
            </div>
          </template>
          <template #default="{ row }">
            <div>
              直播：{{ row.liveSettledCnt
              }}<span>（{{ row.liveSettledAmountBd }}元）</span>
            </div>
            <div>
              其他：{{ row.otherSettledCnt
              }}<span>（{{ row.otherSettledAmountBd }}元）</span>
            </div>
            <div>
              短视频：{{ row.videoSettledCnt
              }}<span>（{{ row.videoSettledAmountBd }}元）</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="agentCommissionBd" label="代理佣金">
          <template #default="{ row }">
            <div class="color-red">{{ row.agentCommissionBd }}元</div>
            <div> (已含销售溢价：<span
                :style="{ color: row.settledPremiumTotalBd > 0 ? 'green' : row.settledPremiumTotalBd === 0 ? 'black' : 'red' }">

                {{ row.settledPremiumTotalBd }}元
              </span>)

            </div>

          </template>
        </el-table-column>
        <el-table-column prop="address" label="结佣状态">
          <template #default="{ row }">
            <div>{{ row.payStatusStr }}</div>
            <!-- 已结佣状态下说明 -->
            <div v-if="row.payStatus === 10">
              <div>
                结佣方式：{{ row.settleTypeStr
                }}<span v-if="row.settleType === 1">{{ row.specSettleRatio }}%</span>
              </div>
              <div>结佣时间：{{ row.payTimeStr }}</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页-->
      <el-pagination v-if="table.total" class="table-pagination" @size-change="onSizeChange"
        @current-change="onCurrentChange" :current-page.sync="pagination.pageNo" :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="table.total" />
    </div>
  </div>
</template>

<script>
import mini from "@/api/mini";
const MiniModel = new mini()
import douYin from "@/javaApi/douyin";
const DouYinModel = new douYin();
import { formatDate } from "@/utils/tool"
import setSettlement from './SetSettlement'
const searchParams = {
  agent: '', // 代理
  time: [], // 时间
  appKey: '', // 小程序key
  fidOrName: '', // 达人昵称
  payStatus: '', // 结佣状态
  payTime: '' // 结佣时间
};
export default {
  components: {
    setSettlement,// 发起结佣
  },
  data() {
    return {
      exportLoading: false,// 导出loading
      payStatusList: [
        // 结佣状态
        {
          value: '',
          label: '全部'
        },
        {
          value: 0,
          label: '未结佣'
        },
        {
          value: 5,
          label: '结佣中'
        },
        {
          value: 10,
          label: '已结佣'
        },
        {
          value: 20,
          label: '结佣失败'
        }
      ], //  结佣状态
      searchForm: Object.assign({}, searchParams), // 搜索数据
      pagination: {
        // 分页
        pageSize: 10, // 表格分页页数
        pageNo: 1, // 表格当前页数
      },
      table: {
        // selectRowsIds: [], // 选中数据
        // 表格
        dataSource: [], // 表格数据
        total: 0, // 总数
        loading: false, // 表格加载loading
      },
      pickerOptions: {
        // 日期限制
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      }
    };
  },
  mounted() {
    this.freshTable();
  },
  methods: {

    // 刷新
    onRefresh() {
      this.freshTable();
    },

    // 表单搜素
    onFormSearch() {
      this.pagination.pageNo = 1;
      this.freshTable();
    },
    // 表单重置`
    onFormReset() {
      this.searchForm = Object.assign({}, searchParams);
      this.pagination.pageSize = 10;
      this.onFormSearch();
    },
    // 分页数据变化
    onSizeChange(val) {
      this.pagination.pageSize = val;
      this.freshTable();
    },
    // 分页跳转
    onCurrentChange() {
      this.freshTable();
    },
    // 请求表格·
    async freshTable() {
      this.table.loading = true;
      const params = { ...this.searchForm, ...this.pagination }
      params.beginTime = params.time && params.time.length ? params.time[0] : ''
      params.endTime = params.time && params.time.length ? params.time[1] : ''
      delete params.time
      const data = await DouYinModel.getAgencySettlePage(params).finally(() => {
        this.table.loading = false;
      });
      if (data.data.code === 200) {
        this.table.dataSource = data.data.data.list;
        this.table.total = data.data.data.total;
      } else {
        this.$message.error(data.data.message)

      }
    },
    // 导出数据
    onFormExport() {
      this.exportLoading = true
      const params = { ...this.searchForm, ...this.pagination }
      params.beginTime = params.time && params.time.length ? params.time[0] : ''
      params.endTime = params.time && params.time.length ? params.time[1] : ''
      delete params.time
      DouYinModel.userDataExport(params).then((res) => {
        const blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
        console.log("blob", blob);
        let url = window.URL.createObjectURL(blob);
        console.log("url", url);
        var a = document.createElement("a");
        document.body.appendChild(a);
        a.href = window.URL.createObjectURL(blob);
        a.download = "订单列表" + formatDate(new Date()) + ".xls";
        a.click();
        window.URL.revokeObjectURL(url);
        this.exportLoading = false
        this.$message({
          message: "导出成功",
          type: "success",
        });
      }).catch(() => {
        this.exportLoading = false
      })
    },
  },
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/userData/index.vue